import { initialTopics } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/supportReview/supportTopics/config'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const generateCrudWithMemo = () => {
  const memo = {}
  return (index: number) => {
    if (!memo[index]) {
      memo[index] = new Crud({
        fetcher: new Static(initialTopics.map((el) => ({ key: el, label: el }))),
        keyField: 'key',
      })
    }

    return memo[index]
  }
}
